// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"93c13208","160":"fe31e4e6","198":"3c987a03","208":"7bfde5bd","293":"777b9821","516":"278849d5","519":"9bd637e4","917":"541eb35a","946":"40cc3e85"}[chunkId] + ".chunk.js";
};